import { render } from "./SidebarMTAdmin.vue?vue&type=template&id=b817d85a&scoped=true"
import script from "./SidebarMTAdmin.vue?vue&type=script&lang=js"
export * from "./SidebarMTAdmin.vue?vue&type=script&lang=js"

import "./SidebarMTAdmin.vue?vue&type=style&index=0&id=b817d85a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b817d85a"]])

export default __exports__